module.exports = __webpack_public_path__ + "static/img/notice_preview.a8a8fcec.png";